import { useSettingsStore } from "@/data/settingsStore";

export const BAROMETER_CONFIG_KEY = "kaynin_barometer_config";

export interface BarometerTabConfig {
  id: string;
  visible: boolean;
  labelFr: string;
  labelAr: string;
  labelAmz: string;
}

export interface BarometerConfig {
  titleFr: string;
  titleAr: string;
  titleAmz: string;
  subtitleFr: string;
  subtitleAr: string;
  subtitleAmz: string;
  status: "active" | "pending"; // 'pending' affiche un message d'attente
  manualMode: boolean; // Si true, utiliser les données manuelles au lieu des candidats
  tabs: BarometerTabConfig[];
  manualData?: any; // Pour plus tard si on implémente la saisie complète
}

const DEFAULT_CONFIG: BarometerConfig = {
  titleFr: "Baromètres d'Accréditation des Candidats",
  titleAr: "مؤشرات تزكية المترشحين",
  titleAmz: "ⵉⵙⵖⴰⵍⵏ ⵏ ⵓⵙⵖⵣⵏ ⵏ ⵉⵎⵙⵜⴰⵢⵏ",
  subtitleFr: "Données consolidées au fur et à mesure des accréditations • actualisation automatique • Élections législatives 2026",
  subtitleAr: "بيانات مجمعة تباعا مع التزكيات • تحديث تلقائي • انتخابات 2026",
  subtitleAmz: "ⵉⵙⴼⴽⴰ ⵉⵜⵜⵓⵙⵎⵓⵏⵏ ⵉⵎⵉⴽ ⵙ ⵉⵎⵉⴽ ⴷ ⵉⵙⵖⵣⴰⵏ • ⴰⵙⴷⴷⵉⴷ ⴰⵡⵜⵓⵎⴰⵜⵉⴽⵉ • ⵜⵉⵙⵜⴰⵢⵉⵏ ⵜⵉⵣⵔⴼⴰⵏⵉⵏ 2026",
  status: "active",
  manualMode: false,
  tabs: [
    { id: "party", visible: true, labelFr: "Par Parti", labelAr: "حسب الحزب", labelAmz: "ⵙ ⵓⴽⴰⴱⴰⵔ" },
    { id: "region", visible: true, labelFr: "Par Région", labelAr: "حسب الجهة", labelAmz: "ⵙ ⵜⵎⵏⴰⴹⵜ" },
    { id: "gender", visible: true, labelFr: "Genre", labelAr: "مؤشر الجنس", labelAmz: "ⴰⵏⴰⵡ" },
    { id: "age", visible: true, labelFr: "Âge", labelAr: "مؤشر العمر", labelAmz: "ⴰⵡⵜⴰⵢ" },
    { id: "sociopro", visible: true, labelFr: "Catégorie Sociopro", labelAr: "الفئة المهنية", labelAmz: "ⵜⴰⵙⵎⵉⵍⵜ ⵜⴰⵣⵣⵓⵍⴰⵏⵜ" },
  ]
};

export function getBarometerConfig(): BarometerConfig {
  const saved = useSettingsStore.getState().getSetting(BAROMETER_CONFIG_KEY, "");
  if (saved && typeof saved === "string") {
    try {
      const parsed = JSON.parse(saved);
      // Migration: Update old hardcoded subtitles to the new ones
      if (parsed.subtitleFr === "Données saisies par les partis • actualisation automatique • Élections législatives 2026") {
        parsed.subtitleFr = DEFAULT_CONFIG.subtitleFr;
      }
      if (parsed.subtitleAr === "بيانات مقدمة من الأحزاب • تحديث تلقائي • انتخابات 2026") {
        parsed.subtitleAr = DEFAULT_CONFIG.subtitleAr;
      }
      if (parsed.subtitleAmz === "ⵉⵙⴼⴽⴰ ⵏ ⵉⴽⴰⴱⴰⵔⵏ • ⴰⵙⴷⴷⵉⴷ ⴰⵡⵜⵓⵎⴰⵜⵉⴽⵉ • ⵜⵉⵙⵜⴰⵢⵉⵏ ⵜⵉⵣⵔⴼⴰⵏⵉⵏ 2026") {
        parsed.subtitleAmz = DEFAULT_CONFIG.subtitleAmz;
      }
      return { ...DEFAULT_CONFIG, ...parsed, tabs: parsed.tabs || DEFAULT_CONFIG.tabs };
    } catch {
      return DEFAULT_CONFIG;
    }
  }
  return DEFAULT_CONFIG;
}

export function saveBarometerConfig(config: BarometerConfig) {
  useSettingsStore.getState().updateSetting(BAROMETER_CONFIG_KEY, JSON.stringify(config));
}
